import BaseDialog from '../BaseDialog';

const UserUpdateDialog = ({ isVisible, onClose, message = 'ユーザーデータの更新が完了しました。' }) => {
    return (
      <BaseDialog isVisible={isVisible} onClose={onClose}>
        <div>
          {message}
        </div>
      </BaseDialog>
    );
};

export default UserUpdateDialog;
